module.exports = __webpack_public_path__ + "img/pokedex.9dd43409.png";